import { Alert, Button, Group, Stack, Text, Title } from "@mantine/core";
import { useCallback } from "react";
import { useNavigate } from "react-router";

import { PuzzleGame } from "../components/PuzzleGame";
import { useTodaysPuzzle } from "../hooks/useTodaysPuzzle";
import { newRandomBlendSeed } from "../puzzle";

export function Home() {
  const result = useTodaysPuzzle();
  const navigate = useNavigate();

  const playRandom = useCallback(() => {
    void navigate(`/blend/${newRandomBlendSeed()}`);
  }, [navigate]);

  const actions = (
    <Group>
      <Button variant="default" size="xs" onClick={playRandom}>
        🎲 play a random blend
      </Button>
    </Group>
  );

  if (result?.status === "pending") {
    return (
      <Stack gap="md" maw={720}>
        <Title order={2}>today&rsquo;s puzzle</Title>
        <Alert color="blue" title="puzzle landing soon">
          <Text size="sm">
            today&rsquo;s puzzle hasn&rsquo;t been anchored on-chain yet. check
            back in a few minutes — or play a random blend in the meantime.
          </Text>
        </Alert>
        {actions}
      </Stack>
    );
  }

  if (result?.status === "unavailable") {
    return (
      <Stack gap="md" maw={720}>
        <Title order={2}>today&rsquo;s puzzle</Title>
        <Alert color="red" title="puzzle service unavailable">
          <Text size="sm">
            the CogQuest service can&rsquo;t reach the chain right now.
            {result.retryAfterSeconds !== undefined && (
              <>
                {" try again in ~"}
                {result.retryAfterSeconds}
                {" seconds."}
              </>
            )}
          </Text>
        </Alert>
        {actions}
      </Stack>
    );
  }

  const puzzle = result?.status === "ok" ? result.puzzle : undefined;
  const stale = result?.status === "ok" ? result.stale : false;

  return (
    <PuzzleGame
      puzzle={puzzle}
      heading="today's puzzle"
      blendLabel="today's blend"
      metaLabel={() => puzzle?.resolvedFor ?? ""}
      storageId={puzzle?.resolvedFor}
      stale={stale}
      actions={actions}
    />
  );
}
